import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type { FindAppsDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsAndroidFiltersDto } from "app/pages/sales-intelligence/store/find-apps/types";
import countryService from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import AppAndroidDownloadAndEngagementFilter from "../../components/filters/AppDownloadEngagementFilter/android/AppAndroidDownloadAndEngagementFilter";
import AppAndroidDownloadEngagementFilterResult from "../../components/filters/AppDownloadEngagementFilter/android/AppAndroidDownloadAndEngagementFilterResult";

import FindAndroidDownloadAndEngagementFilter from "./AndroidDownloadAndEngagementFilter";

const createAndroidDownloadAndEngagementFilter = (
    description: FindAppsDescriptionDto,
): IFilterInstance<IAppsAndroidFiltersDto> => {
    const countries = countryService.getCountriesByIds(description.androidDownloadsAndEngagement.supportedCountries);
    return {
        key: "downloadsAndEngagement",
        trackingName: "App Downloads and Engagement",
        title: { key: "si.find_apps.filters.android-download-and-engagement.title" },
        tooltipText: { key: "si.find_apps.filters.android-download-and-engagement.tooltip" },
        filter: new FindAndroidDownloadAndEngagementFilter({
            options: description.androidDownloadsAndEngagement,
            initialDtoValue: {
                country: WORLDWIDE_COUNTRY_ID,
            },
            countries,
        }),
        filterView: AppAndroidDownloadAndEngagementFilter,
        filterResultView: AppAndroidDownloadEngagementFilterResult,
    };
};

export default createAndroidDownloadAndEngagementFilter;
